import { PropTypes } from "prop-types"
import { Paper } from "@mui/material"
import { NewReleases } from "@mui/icons-material"
import "./styles.scss"

export default function NoData({ autoRefresh }) {
  return <Paper className="components_intraday-no-data">
    <div className="warning-icon"><NewReleases /></div>
    <div className="message">
      <div className="title">No intraday data to display</div>
      <div>The portfolio has not yet been updated with any intraday data. {autoRefresh ? "This page will auto-refresh when new data is available." : ""}</div>
    </div>
  </Paper>
}

NoData.propTypes = {
  autoRefresh: PropTypes.bool,
}
